module.exports = __webpack_public_path__ + "img/4064009240.fb3026c3.jpg";